import styled from 'styled-components'

export const ErrorContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4198b9;
  background: #181d20;
  box-shadow: inset 0 0 35px 10px #4b585d;
  z-index: 1;
`

export const ErrorBox = styled.div`
  height: 100%;
  width: 315px;
  position: relative;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  font-size: 20px;
  text-align: center;
`
// export const NoSignalContent = styled.div<{ reload: boolean }>`
//   text-align: center;
//   p {
//     line-height: 1.6;
//   }
// `
// export const NoSignalBtn = styled.div`
//   border-radius: 38px;
//   width: 100%;
//   padding: 0 15px;
//   text-transform: uppercase;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-size: 20px;
//   height: 56px;
//   max-width: 315px;
//   border: solid 3px #4198b9;
// `
